// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Launch poster modal ===== */
.launch-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  /* Dim the rest of the page "a little" behind the poster */
  background: rgba(20, 12, 28, 0.6);
  backdrop-filter: blur(2px);
  animation: launch-fade 0.25s ease;
}

.launch-dialog {
  position: relative;
  max-width: 96vw;
  max-height: 88vh;
  animation: launch-pop 0.3s ease;
}

/* Two posters shown side by side */
.launch-posters {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
}

/* Posters are tall portraits (9:16) — constrain by height so both fit on
   screen, width follows the ratio. */
.launch-posters img {
  display: block;
  max-height: 84vh;
  max-width: 46vw;
  width: auto;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

/* Close button — top-right, just outside the poster corner */
.launch-close {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #2a1a3a;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  transition: background 0.2s ease, transform 0.2s ease;
}

.launch-close:hover {
  background: #4a2a5a;
  transform: scale(1.08);
}

@keyframes launch-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes launch-pop {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

/* ===== Phone ===== */
@media (max-width: 640px) {
  .launch-overlay {
    padding: 12px;
  }

  .launch-posters {
    gap: 8px;
  }

  .launch-posters img {
    max-width: 47vw;
  }

  .launch-close {
    top: -10px;
    right: -10px;
    width: 34px;
    height: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LaunchModal/launch-modal.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAA0D;EAC1D,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;qCACqC;AACrC;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ===== Launch poster modal ===== */\n.launch-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  /* Dim the rest of the page \"a little\" behind the poster */\n  background: rgba(20, 12, 28, 0.6);\n  backdrop-filter: blur(2px);\n  animation: launch-fade 0.25s ease;\n}\n\n.launch-dialog {\n  position: relative;\n  max-width: 96vw;\n  max-height: 88vh;\n  animation: launch-pop 0.3s ease;\n}\n\n/* Two posters shown side by side */\n.launch-posters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Posters are tall portraits (9:16) — constrain by height so both fit on\n   screen, width follows the ratio. */\n.launch-posters img {\n  display: block;\n  max-height: 84vh;\n  max-width: 46vw;\n  width: auto;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n}\n\n/* Close button — top-right, just outside the poster corner */\n.launch-close {\n  position: absolute;\n  top: -14px;\n  right: -14px;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  background: #2a1a3a;\n  color: #fff;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.launch-close:hover {\n  background: #4a2a5a;\n  transform: scale(1.08);\n}\n\n@keyframes launch-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes launch-pop {\n  from { opacity: 0; transform: scale(0.92); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n/* ===== Phone ===== */\n@media (max-width: 640px) {\n  .launch-overlay {\n    padding: 12px;\n  }\n\n  .launch-posters {\n    gap: 8px;\n  }\n\n  .launch-posters img {\n    max-width: 47vw;\n  }\n\n  .launch-close {\n    top: -10px;\n    right: -10px;\n    width: 34px;\n    height: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
